import Axios from 'axios'
import { Configuration } from './../config/config.env'

export class ApiRequestService {
  constructor(baseURL) {
    this.baseURL = baseURL || Configuration.ROUTE
    // console.log('Configuration.CONFIG.ROUTE', Configuration.ROUTE)
    this.axiosService = Axios.create({
      baseURL: this.baseURL,
      // timeout: 60000,
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
      },
    })

    this.axiosPutService = Axios.create({
      baseURL: this.baseURL,
    })
  }

  getApi(path, headers = {}, params = {}) {
    return new Promise((resolve) => {
      this.axiosService
        .get(path, {
          headers,
          params,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.code === 200,
            statusText: 'Success',
            data: res.data.data,
          })
        })
        .catch((error) => {
          resolve({
            message: error?.response?.data?.error,
            status: false,
            statusText: 'Error',
          })
        })
      // .then(() => {
      //     // here the code which should be excuted always
      // })
    })
  }

  postApi(path, apiData, headers = {}) {
    return new Promise((resolve, reject) => {
      this.axiosService
        .post(path, apiData, {
          headers,
        })
        .then((res) => {
          //   console.log('res', res)
          resolve({
            message: res.data ? res.data.message : '',
            status: res.data.code === 200,
            statusText: 'Success',
            data: res.data,
          })
        })
        .catch((error) => {
          console.log('err', error)
          resolve({
            message: error?.response?.data?.error,
            status: false,
            statusText: 'Error',
            NewData: error?.response?.data,
          })
        })
      // .then(() => {
      //     // here the code which should be excuted always
      // })
    })
  }

  deleteApi(path, headers = {}) {
    return new Promise((resolve) => {
      this.axiosService
        .delete(path, {
          headers,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.code === 200,
            statusText: 'Success',
            data: res.data.data,
          })
        })
        .catch((error) => {
          resolve({
            message: error?.response?.data?.error,
            status: false,
            statusText: 'Error',
          })
        })
      // .then(() => {
      //     // here the code which should be excuted always
      // })
    })
  }

  putApi(path, apiData, headers) {
    return new Promise((resolve) => {
      this.axiosPutService
        .put(path, apiData, { headers })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.code === 200,
            statusText: 'Success',
            data: res.data.data,
          })
        })
        .catch((error) => {
          resolve({
            message: error?.response?.data?.error,
            status: false,
            statusText: 'Error',
          })
        })
      // .then(() => {
      //     // here the code which should be excuted always
      // })
    })
  }
}

export default ApiRequestService
